try {
    if (process.env.TOKENS_FEATURE_FLAG === 'true' || process.env.STORYBOOK_TOKENS_FEATURE_FLAG !== 'false') require('./index-new.css');
    else require('./index.css');
  } catch (e) {
    if (e.code !== 'MODULE_NOT_FOUND') {
      throw e; // Re-throw unexpected errors
    }
    console.warn('index.css / index-new.css not found, proceeding without it.');
  }


import { jsx } from 'react/jsx-runtime';
import { Button } from '@design-system/button';
import { Link } from '@design-system/link';
import classNames from 'classnames';
import { forwardRef } from 'react';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function __rest(s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

const CtaBlock = forwardRef((_a, ref) => {
    var { stacked, className, ButtonComponent = Button, LinkComponent = Link, data, align = 'start' } = _a, htmlProperties = __rest(_a, ["stacked", "className", "ButtonComponent", "LinkComponent", "data", "align"]);
    return (jsx("div", Object.assign({ ref: ref, className: classNames('cds-cta-block', className, {
            'cds-cta-block--stacked': stacked,
            [`cds-justify--${align}`]: !stacked,
            [`cds-align--${align}`]: stacked,
        }), "data-testid": "cds-cta-block" }, htmlProperties, { children: data.map((_a, index) => {
            var { elementType } = _a, props = __rest(_a, ["elementType"]);
            const key = elementType + index;
            if (elementType === 'button') {
                return jsx(ButtonComponent, Object.assign({}, props), key);
            }
            if (elementType === 'link') {
                return jsx(LinkComponent, Object.assign({}, props), key);
            }
            return null;
        }) })));
});

export { CtaBlock };
